import { VERIFY_EMAIL, VERIFY_EMAIL_DONE, VERIFY_EMAIL_ERR, RESET_EMAIL_VERIFICATION } from './actionTypes';
import { defaultInitialState, loadingState, updatedState, getErrorState } from '../utils';
const initialState = Object.assign({}, defaultInitialState);
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case VERIFY_EMAIL:
            return Object.assign(Object.assign({}, state), loadingState);
        case VERIFY_EMAIL_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), updatedState), { data: action.data });
        case VERIFY_EMAIL_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case RESET_EMAIL_VERIFICATION:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map